export enum MessageType {
  POSITION = 0,
  TOAST_START = 1,
  TOAST_IN_PROGRESS = 2,
  TOAST_END = 3,
  CONVO_START = 4,
  CONVO_IN_PROGRESS = 5,
  CONVO_END = 6,
  PLAYLIST_CHANGED,
  SHOULD_SHOW_LEARN_MORE_BANNER,
  ARTIFACTS_TOGGLE,
  PHOTO_BOOTH_START,
  SHARE_SCREEN_START,
  NEW_HOST,
}

export default MessageType;
